import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from "@/api/PMS/report/proReport.js"; // import { fetchList as fetchTypeList } from "@/api/PMS/communityPartyBuilding/activityType";

import waves from "@/directive/waves"; // 水波纹指令

import { formatJson } from "@/utils/index";
export default {
  name: "ProReport",
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        activityType: '',
        itemName: ''
      },
      dates: [],
      options: [{
        activityTypeName: '活动报名',
        id: 1
      }, {
        activityTypeName: '场地预定',
        id: 2
      }, {
        activityTypeName: '共享空间',
        id: 3
      }, {
        activityTypeName: '演艺票务',
        id: 4
      }, {
        activityTypeName: '游泳票务',
        id: 5
      }],
      multipleSelection: []
    };
  },
  created: function created() {
    this.defaultDate(); // 获取路由的配置
    // let appType = this.$route.query.appType;
    // if (appType !== undefined) {
    //   this.listQuery.appType = parseInt(appType);
    // }

    this.getList(); // this.getTypeOption();
  },
  methods: {
    // 初始化默认时间
    defaultDate: function defaultDate() {
      var date = new Date();
      var year = date.getFullYear().toString();
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
      var day = new Date(date.getFullYear(), month, 0).getDate();
      day < 10 ? '0' + day.toString() : day.toString();
      var beg = year + '-' + month + '-01';
      var end = year + '-' + month + '-' + day;
      this.dates = [beg, end];
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    // getTypeOption () {
    //   fetchTypeList({ page: 1, appType: this.listQuery.appType }).then(res => {
    //     this.options = res.data.data;
    //   });
    // },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    handleExport: function handleExport() {
      var _this2 = this;

      this.exLists = [];
      this.$confirm("你确定要导出订单项目统计报表吗, 是否继续?", "提示").then(function () {
        var beginDate = "";
        var endDate = "";

        if (_this2.dates !== null && _this2.dates.length > 0) {
          beginDate = _this2.dates[0];
          endDate = _this2.dates[1];
        }

        fetchList({
          activityType: _this2.listQuery.activityType,
          itemName: _this2.listQuery.itemName,
          coachId: _this2.listQuery.coachId,
          endDate: endDate,
          beginDate: beginDate
        }).then(function (response) {
          var list = response.data.data;

          if (list !== null && list.length > 0) {
            var arrayWithIndex = list.map(function (item, index) {
              return _objectSpread({
                index: index + 1
              }, item);
            });
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["序号", "项目名称", "项目类型", "结算日期", "支付结算金额（元）"];
              var fileterVal = ["index", "orderName", "subject", "createTime", "orderAmount"];
              var multiHeader = [["订单项目统计报表", "", "", "", ""]];
              var merges = ["A1:E1"];
              var data = formatJson(fileterVal, arrayWithIndex);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                merges: merges,
                multiHeader: multiHeader,
                filename: "订单项目统计报表",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this2.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};